import { render } from "./App.vue?vue&type=template&id=72f8eae3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=72f8eae3&lang=css"

import exportComponent from "C:\\8 Extension Folder\\8.0 Extension Folder\\8.02\\SMMPortfolioSite\\photographydays-login\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__